// const BASE_URL = "http://localhost:3001";
const BASE_URL = "https://api.missingpeoplesapp.com/";

const API_URL = BASE_URL + "api/admin/";

const INITIAL_TOKEN = "68bdbd1c-a197-4d78-9483-3f8f292a42be";

export { API_URL, BASE_URL, INITIAL_TOKEN };
